export default __webpack_public_path__ + "static/media/50.5dbbec09.png";